import React from "react";
import PropTypes from "prop-types";
import WorkInfoInputComponent from "../input/WorkInfoInputComponent";
import UserDataService from "../../common/UserDataService";
import {setupOnExtractData} from "../../../util/FormUtil";

class WorkInfoComponent extends React.Component {
    constructor(props){
        super(props);
        this.setExtractData = this.setExtractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    setExtractData(func){
        this.extractData = func;
    }

    render(){
        const {data, metadata, setFormState, userDataInit, userDataService, phoneRequired=true, countryCodeWidth,
            onError, allowSkipPhoneInput,skipIpStackServiceCall} = this.props;
        const headerLabel = allowSkipPhoneInput ? "Primary Work Address" : "Primary Work Address / Primary Phone Number";
        return (
            <div className="grid">
                <div className="grid__col-md-3 grid__col-sm-12">
                    {headerLabel}
                </div>
                <div className="grid__col-md-9 grid__col-sm-12">
                    <WorkInfoInputComponent
                        data={data}
                        metadata={metadata}
                        userDataService={userDataService}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        onExtractData={this.setExtractData}
                        phoneRequired={phoneRequired}
                        countryCodeWidth={countryCodeWidth}
                        allowSkipPhoneInput={allowSkipPhoneInput}
                        onError={onError}
                        skipIpStackServiceCall={skipIpStackServiceCall}
                    />
                </div>
            </div>
        );
    }
}

WorkInfoComponent.propTypes = {
    countryCodeWidth: PropTypes.string,
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    onExtractData: PropTypes.func,
    phoneRequired: PropTypes.bool,
    allowSkipPhoneInput: PropTypes.bool,
    onError: PropTypes.func.isRequired
};

export default WorkInfoComponent;